module.exports = __webpack_public_path__ + "img/ab.505e694f.webp";